import { Component, computed, inject, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { requestInterface } from 'src/app/util/interfaces/request';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { LabelsService } from 'src/app/util/services/labels/labels.service';

@Component({
	selector: 'pcp-request-page-tab-related-kb',
	standalone: true,
	imports: [RouterModule, FontAwesomeModule],
	templateUrl: './request-page-tab-related-kb.component.html',
	styleUrl: './request-page-tab-related-kb.component.scss',
})
export class RequestPageTabRelatedKbComponent {
	private readonly labelsService = inject(LabelsService);
	icons = {
		faExternalLinkAlt: faExternalLinkAlt,
	};
	labels: LabelsInterface;

	@Input() requestData: requestInterface;

	constructor() {
		this.labels = computed(() => this.labelsService.labels())();
	}
}
